import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {BlendedModelsAllocationService} from '@irb/irb-editors/editor-blended-model/blended-models-allocation.service';
import {EditorModelService} from '@irb/irb-editors/editor-model/editor-model.service';
import {BlendedSecurityAllocationService} from '@irb/irb-editors/editor-blended-model/blended-security-allocation/blended-security-allocation.service';
import {Subscription} from 'rxjs';
import {IrbSettingsService} from '@irb/irb-settings/irb-settings.service';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {CellClickedEvent} from "ag-grid-community";
import {AppService} from "@irb/app.service";


@Component({ standalone: false,
  selector: 'irb-blended-security-allocation',
  templateUrl: './blended-security-allocation.component.html',
  styleUrls: ['./blended-security-allocation.component.scss']
})
export class BlendedSecurityAllocationComponent implements OnInit, OnDestroy {

  gridData: any = [];
  grid: any;
  gridOptions: any;
  rowCount: number = 0;
  detailCellRendererParams: any;
  height: string = "320px";
  private editDataChangeSubscription: Subscription;
  totalPercent: number = 0;
  private initLoading: boolean = true;
  private getGlobalSettingsSubscription: Subscription;
  isUiTest: boolean = false;
  frameworkComponents: any;
  ENABLE_AS_SECTYPE: boolean = false;
  @Input()
  data: any;
  componentName: string = 'BlendedSecAllocationsComponent-v001';

  constructor(private bmas: BlendedModelsAllocationService,
              private editorModelService: EditorModelService,
              private as: AppService,
              public iss: IrbSettingsService,
              private ies: IrbEditorsService,
              private bsas: BlendedSecurityAllocationService) {
    this.ENABLE_AS_SECTYPE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_AS_SECTYPE;
    const isTlhWsaEnabled = this.as.getItem('IRB_APP_CONFIG')?.isTlhWsaEnabled;
    let gridColumns: any = this.bsas.getSecAllocColumnDefs(this);
    if (isTlhWsaEnabled) {
      let globalSettings = this.editorModelService.getGlobalSettings() || {};
      const isTLHSetInGlobal = globalSettings.isTlhLotLevel || globalSettings.isTlhPositionLevel;
      const colsTlhWsa: any = this.bsas.getTlhWsaColumns(isTLHSetInGlobal);
      gridColumns[4].children = gridColumns[4].children.concat(colsTlhWsa);
    }

    if(this.ENABLE_AS_SECTYPE) {
      this.componentName = "BlendedSecAllocationsComponent-v002";
    }

    this.gridOptions = {
      columnDefs: gridColumns,
      context: {componentParent: this, parentId: 'edit-blended-sec-allocation-grid'},
      embedFullWidthRows: true,
      floatingFilter: false,
      treeData: true,
      getRowId: (params: any) => {
        const isLot: boolean = params.data.parentChildId ? true : false;
        return (isLot) ? params.data.parentChildId : params.data.securityId;
      },
      getDataPath: (data: any) => {
        if (this.isUiTest) {
          if (!data) {
            data = {parentChildId: false, securityId: 111}
          } else {
            data.parentChildId = false;
          }
        }
        const isLot: boolean = data.parentChildId ? true : false;
        return (isLot) ? [data.securityId.toString(), data.parentChildId.toString()] : [data.securityId.toString()];
      },
      // treeDataDisplayType: 'custom',
      groupDisplayType: 'custom',
      onDragStopped: () => {
        this.setTotalPercent();
      },
      onToolPanelVisibleChanged: () => {
        this.setTotalPercent();
      },
      onCellClicked:  this.onSecurityAllocationsGridCellClicked.bind(this)
    };

    this.frameworkComponents = this.bsas.getFrameworkComponents();
  }

  ngOnInit(): void {
    this.editDataChangeSubscription = this.bmas.dataChanged.subscribe(()=> {
      this.load();
    });
    setTimeout(() => {
      this.initLoading = false;
    }, 1000);

    this.getGlobalSettingsSubscription = this.bmas.globalSettingsSubject.subscribe(() => {
      this.updateCategoryLabel();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this.setTotalPercent();
    }, 200);
  }

  load() {
    this.gridData = this.bmas.getAllocationSecurities();
    if (this.gridData) {
      this.buildHierarchy();
      this.updateGrid();
    }
  }

   onGridReady(params: any) {
    this.grid = params;
    this.load();
    this.updateCategoryLabel();
  }

  private buildHierarchy() {
    let childArray: any = [];
    this.gridData.forEach((sec: any) => {
      childArray = childArray.concat(sec.childItems);
    });
    this.gridData = this.gridData.concat(childArray);
  }

  updateCategoryLabel() {
    let globalSettings = this.bmas.getGlobalSettingValues();
    if (globalSettings && globalSettings.securityCustAttrAbbr && this.grid && this.grid.api) {
      this.grid.api.getColumnDef("customCategoryName").headerName = globalSettings.securityCustAttrAbbr;
      this.grid.api.refreshHeader();
    }
  }

  private updateGrid() {
    this.rowCount = this.gridData.length;
    if (this.grid && this.grid.api) {
      this.grid.api.setGridOption('rowData', this.gridData);
    }
    setTimeout(() => {
      this.setTotalPercent();
    }, 200);
  }


  setTotalPercent() {
    this.totalPercent = 0;
    let totalP: number = 0;
    if (this.gridData) {
     this.gridData.forEach((sec: any) => {
       if (sec && !sec.parentChildId) {
         totalP += Number(sec.weightedTarget);
       }
     });
    }

    const t = this.bmas.getTotalPercentForBlended();
    if (t) {
      totalP = Number(t);
    }

    this.totalPercent = Number(totalP.toFixed(2));
    let agridHeaderTargets = document.querySelectorAll('#edit-blended-sec-allocation-grid .ag-header-cell');
    let totalWidthLeft = 0;
    if(agridHeaderTargets && agridHeaderTargets.length > 0) {
      let targetElIndex: any = 4;
      agridHeaderTargets.forEach((targetEl,index)=>{
        if(targetEl.classList.contains('editHeaderModelPercent')) {
          targetElIndex = index;
        }
      });
      for(let i =0; i< targetElIndex;i++) {
        let elPos = agridHeaderTargets[i].getBoundingClientRect();
        totalWidthLeft+= elPos.width;
      }

      const headerTarget = document.querySelector('.editHeaderSecAllPercent');
      if (headerTarget) {
        const pos = headerTarget.getBoundingClientRect();
        const totalValEl: any = document.querySelector('#edit-blended-sec-allocation-grid-totalper');
        if (totalValEl) {
          totalValEl.style.left = totalWidthLeft + 'px';
          totalValEl.style.width = pos.width + 'px';
          totalValEl.innerHTML = totalP.toFixed(2);
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.editDataChangeSubscription) {
      this.editDataChangeSubscription.unsubscribe();
    }
    if (this.getGlobalSettingsSubscription) {
      this.getGlobalSettingsSubscription.unsubscribe();
    }
  }
  onSecurityAllocationsGridCellClicked(event: CellClickedEvent) {
    if(event.column.getColId() === 'securitySymbol') {
      if(event.node.isExpandable() && event.node.expanded) {
        event.node.setExpanded(false);
      } else if (event.node.isExpandable() && !event.node.expanded) {
        event.node.setExpanded(true);
      }
    }
  }
}
